import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch, useSelector } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser, profileSuccess } from "../store/actions";
import { useParams } from "react-router-dom";
import axios from "axios";


const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const params = useParams()
  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));

  //  const { userProfile, loading, token } = useProfile();
  const { token } = useProfile();

   useEffect(() => {
    if (!user && token) {
      setAuthorization(token);
      axios.get('/me').then((response) => {
        dispatch(profileSuccess(response.data))
      }).catch((err) => {
        console.error(err)
        dispatch(logoutUser());
      })
    } else if (!user && !token) {
      dispatch(logoutUser());
    }
  }, [token, user]);
  // useEffect(() => {
  //   if (userProfile && !loading && token) {
  //     setAuthorization(token);
  //   } else if (!userProfile && loading && !token) {
  //     dispatch(logoutUser());
  //   }
  // }, [token, userProfile, loading, dispatch]);

  /*
    redirect is un-auth access protected routes via url
  */

  // if (!userProfile && loading && !token) {
  //   return (
  //     <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
  //   );
  // }
  if (!token) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }
  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };